import React from 'react';
import ReactECharts from 'echarts-for-react';
import { metrics } from '../data/mockData';
import SafeIcon from '../components/common/SafeIcon';
import { FiTrendingUp, FiClock, FiCheckSquare, FiHeart } from 'react-icons/fi';

const MetricCard = ({ title, value, icon, trend, isGood }) => (
  <div className="glass-panel p-6 rounded-2xl flex flex-col">
    <div className="flex items-center gap-3 text-slate-400 mb-4">
      <SafeIcon icon={icon} className="text-xl" />
      <span className="text-sm font-medium uppercase tracking-wider">{title}</span>
    </div>
    <div className="flex items-end justify-between mt-auto">
      <span className="text-4xl font-mono font-bold text-white tracking-tight">{value}</span>
      <span className={`text-sm font-medium ${isGood ? 'text-green-400' : 'text-priority-red'}`}>
        {trend}
      </span>
    </div>
  </div>
);

export default function AnalyticsView() {
  const volumeOptions = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'axis' },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisLine: { lineStyle: { color: '#334155' } },
      axisLabel: { color: '#94a3b8' }
    },
    yAxis: {
      type: 'value',
      splitLine: { lineStyle: { color: '#1e293b', type: 'dashed' } },
      axisLabel: { color: '#94a3b8' }
    },
    series: [
      {
        name: 'Tickets',
        data: [120, 132, 101, 134, 90, 230, 210],
        type: 'line',
        smooth: true,
        symbol: 'none',
        lineStyle: { width: 3, color: '#00F0FF' },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(0, 240, 255, 0.3)' },
              { offset: 1, color: 'rgba(0, 240, 255, 0)' }
            ]
          }
        }
      }
    ]
  };

  const satisfactionOptions = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'item' },
    legend: { bottom: '0%', textStyle: { color: '#94a3b8' } },
    series: [
      {
        name: 'CSAT',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#070B14',
          borderWidth: 2
        },
        label: { show: false },
        data: [
          { value: 94, name: 'Positive', itemStyle: { color: '#00F0FF' } },
          { value: 4, name: 'Neutral', itemStyle: { color: '#fbbf24' } },
          { value: 2, name: 'Negative', itemStyle: { color: '#FF2A55' } }
        ]
      }
    ]
  };

  return (
    <div className="flex-1 overflow-y-auto p-8 bg-navy-900 border-l border-navy-700">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-white mb-8">Performance Nexus</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <MetricCard title="CSAT Score" value={`${metrics.csat}%`} icon={FiHeart} trend="+2.4%" isGood={true} />
          <MetricCard title="Avg Response" value={metrics.avgResponseTime} icon={FiClock} trend="-1m" isGood={true} />
          <MetricCard title="Open Queue" value={metrics.openTickets} icon={FiTrendingUp} trend="+12" isGood={false} />
          <MetricCard title="Resolved Today" value={metrics.resolvedToday} icon={FiCheckSquare} trend="+18%" isGood={true} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 glass-panel p-6 rounded-2xl">
            <h3 className="text-lg font-medium text-white mb-4">Ticket Volume (7 Days)</h3>
            <div className="h-80 w-full">
              <ReactECharts option={volumeOptions} style={{ height: '100%', width: '100%' }} />
            </div>
          </div>
          
          <div className="glass-panel p-6 rounded-2xl">
            <h3 className="text-lg font-medium text-white mb-4">Customer Sentiment</h3>
            <div className="h-80 w-full">
              <ReactECharts option={satisfactionOptions} style={{ height: '100%', width: '100%' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}